import React, { Component } from 'react';
import PropTypes from 'prop-types';
import oget from 'oget';
import getUniqueRounds from '../../../../utils/getUniqueRounds';

export default class Contest extends Component {
  static propTypes = {
    contest: PropTypes.object.isRequired,
    onRoundSelect: PropTypes.func.isRequired,
    onContestSelect: PropTypes.func.isRequired,
    selectedContestId: PropTypes.any,
    roundSelected: PropTypes.any,
    colors: PropTypes.shape({
      default: PropTypes.shape({
        backgroundColor: PropTypes.string,
        color: PropTypes.string,
      }),
      active: PropTypes.shape({
        backgroundColor: PropTypes.string,
        color: PropTypes.string,
      }),
    }),
  };

  render() {
    const { contest, onRoundSelect, onContestSelect, selectedContestId, roundSelected = {}, colors } = this.props;

    const showRounds = selectedContestId === contest.externalId;

    return (
      <li className="contest">
        <div className="contest-name" onClick={() => onContestSelect(contest)}>
          {contest.name} <i className={`arrow fa ${showRounds ? 'fa-chevron-down' : 'fa-chevron-right'}`} />
        </div>

        <div className={`rounds ${showRounds ? 'show' : ''}`}>
          {(getUniqueRounds(contest.rounds) || []).map((round, i) => {
            if (!round) {
              return null;
            }

            return (
              <div
                key={`hamburger_round_${i}`}
                className="round"
                onClick={() => {
                  const categories = contest.rounds
                    .filter((item) => item.name === round.name)
                    .map((item) => item.categoryName);
                  onRoundSelect(round, categories);
                }}
                style={round._id === oget(roundSelected, '_id') ? colors.active : colors.default}
              >
                {round.name} {round.state === 'Active' && <span className="active" />}
              </div>
            );
          })}
        </div>
      </li>
    );
  }
}
